import _ from 'lodash';
import moment from 'moment';

export const convertHoursListToBits = (data: any, mode: any) => {
    const hoursArray = new Array(7).fill(0).map(() => new Array(24).fill(0));
    if (mode === 0) {
        const weekHours = _.values(data)[0];
        for (let i = 0; i < 5; i++) {
            fillWeek(i, weekHours, hoursArray);
        }
        const weekendHours = _.values(data)[5];
        for (let i = 5; i < 7; i++) {
            fillWeek(i, weekendHours, hoursArray);
        }
    } else {
        for (let i = 0; i < 7; i++) {
            fillWeek(i, _.values(data)[i], hoursArray);
        }
    }
    const oneDimensionArray: any[] = [];
    hoursArray.forEach((day) => {
        oneDimensionArray.push(...day);
    });
    return oneDimensionArray;
}

/**
 * Fill day of week array
 */

const fillWeek = (dayIndex: number, hours: any, hoursArray: any) => {
    if (hours) {
        Object.keys(hours).forEach((key) => {
            const obj = hours[key];
            const from = moment(obj.from, 'HH:mm');
            const to = moment(obj.to, 'HH:mm');
            if (from.isBefore(to)) {
                while (from.isBefore(to)) {
                    const hour = from.hour();
                    hoursArray[dayIndex][hour] = 1;
                    from.add(1, 'hour');
                }
            }
        })
    }
}

/**
 * Convert array of hours to bits, it's a kind of magic ;)
 * @param hoursArray
 * @param finalHours
 */

export const convertBitsToList = (finalHours: any) => {
    console.log('hours from server: ', finalHours);
    try {
        return convertFromArrayToObject(finalHours);
    }
    catch (e) {
        console.error('ERROR IN BITS CONVERTION: ', e);
        return {};
    }
    return {};

}

const convertFromArrayToObject = (data: any) => {
    const multiDimensional: any[] = convertOneDimensionArrayToMenyDimensions(data, 7, 24);
    const tmp = {};
    multiDimensional.forEach((d: any, ind: number) => {
            _.assign(tmp, {
                [ind]: _.cloneDeep(convertFromArrayToObjectWeek(_.cloneDeep(d)))
            });
        })
    return tmp;
}

const convertFromArrayToObjectWeek = (arrayFromServer: number[]) => {

    const finalArray: any[] = [];
    let from: any = null;
    const defaultMoment = moment('2020-01-01');
    arrayFromServer.forEach((hour, index) => {
        if (hour === 1 && from === null) {
            from = index;
        } else if (from !== null && hour === 0) {
            finalArray.push({
                from: defaultMoment.clone().add(from, 'hours').format('HH:mm'),
                to: defaultMoment.clone().add(index, 'hours').format('HH:mm')
            });
            from = null;
        }
    })
    return finalArray;
};

const convertOneDimensionArrayToMenyDimensions = (oneDimensionArray: any[], numberOfDimensions: number, numberOfElements: number) => {
    const manyDimensionsArray = [];
    for (let i = 0; i < numberOfDimensions; i++) {
        manyDimensionsArray[i] = oneDimensionArray.slice(i * numberOfElements, (i * numberOfElements + numberOfElements));
    }
    return manyDimensionsArray;
}